import { Component, Input } from '@angular/core';

import { Constants, SessionStorageService } from '../_services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'required-field-label',
  template: `
<label [for]="for" class="{{ className || '' }}">
  {{ text }}&nbsp;<span class="asterisk" [attr.aria-label]="ariaLabel">*</span>
</label>`
})
export class RequiredFieldLabelComponent {
  @Input() for: string;
  @Input() className: string;
  @Input() text: string;

  ariaLabel: string = '';

  constructor(sessionState: SessionStorageService) {
    this.ariaLabel = sessionState.getCurrentLanguageCode() === Constants.LanguageCodeFrench
      ? 'Obligatoire'
      : 'Required';
  }
}



// WEBPACK FOOTER //
// ./src/app/global/required-field-label.component.ts